import { Component } from 'react';
import { withRouter } from 'react-router-dom';

/**
 * Composant invisible monté dans <Router>. Remet la page en haut à chaque
 * changement de route.
 *
 * Dans une SPA, le navigateur ne repart pas du haut quand on change de page :
 * il garde la position de défilement. On arrivait donc au milieu d'un article
 * après avoir cliqué dessus depuis le bas de la page d'accueil.
 *
 * À ne pas confondre avec ScrollTop.js, qui est le bouton « retour en haut »
 * affiché en bas à droite.
 *
 * Deux exceptions :
 * - retour arrière (action POP) : le navigateur restaure lui-même la position
 *   qu'on avait sur la page, on ne lui marche pas dessus ;
 * - URL avec une ancre (#sources, #newsletter, sommaire des articles) : c'est
 *   l'ancre qui décide où on atterrit.
 */
class ScrollToTopOnNavigate extends Component {
  componentDidUpdate(prevProps) {
    const { location, history } = this.props;

    if (prevProps.location.pathname === location.pathname) return;
    if (history.action === 'POP') return;
    if (location.hash) return;

    window.scrollTo(0, 0);
  }

  render() {
    return null;
  }
}

export default withRouter(ScrollToTopOnNavigate);
